<div class="button-container">
  <button mat-icon-button mat-dialog-close class="close-button" aria-label="Close">
    <span class="material-symbols-outlined"> cancel </span>
  </button>
</div>

<span class="title" mat-dialog-title>Confirmation</span>
<div mat-dialog-content>
  <p class="body">{{ confirmationMessage }}</p>
</div>
<div class="button-container actions">
  <button class="cancel-button" mat-button (click)="onCancel()">Cancel</button>
  <app-primary-button (eventTriggered)="onConfirm()" text="OK"></app-primary-button>
</div>
